import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS,TRUSTED_DOMAIN } from "../../../common_nextgen/utils/Constants";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad
} from "../../../common_nextgen/utils/UtilFunctions";

const useTrOOPSchedule = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialSelectMode,
  initialLookupType,
  selectModeParamData = {},
  onNavigate
) => {
  const [data, setData] = useState([]);
  // const [paramsData, setParamsData] = useState({
  //   tscScheduleName: "",
  //   tscDescription: "",
  //   hiddenRecordIndicator: "Active",
  // });
  const statusKey = "hiddenRecordIndicator";
  const { axios_helper_no_header } = useAxios();

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [hideFlag, setHideFlag] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const {
    TROOP_SCHEDULE_ADD,
    TROOP_SCHEDULE_DISPLAY,
    TROOP_SCHEDULE_EDIT,
    TROOP_SCHEDULE_STEP,
    COPY_TROOP_SCHEDULE
  } = ROUTE_PATHS;

  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [disabledDropdowns, setDisabledDropdowns] = useState({});

  const screen_title = "TrOOP Schedule";
  // const screenNumber = "RCTSC001";

  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSchedules = [],
    selectedCodesListItem = "",
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      tscScheduleName: "",
      tscDescription: "",
      hiddenRecordIndicator: "Active"
    }
  } = currentState;
  console.log("initial params data", initialParamsData);
  const screenNumber = selectMode ? "RCTSC003" : "RCTSC001";
  const initialParams = selectMode
    ? { ...selectModeParamData, hiddenRecordIndicator: "Active" }
    : initialParamsData;
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(initialParams);

  const formFields = selectMode
    ? [
        {
          fieldLabel: "TSC Schedule Name",
          name: "tscScheduleName",
          label: "Schedule",
          type: "text",
          fieldNature: "editable",
          maxLength: 10
        },
        {
          fieldLabel: "TSC Description",
          name: "tscDescription",
          label: "Description",
          type: "text",
          fieldNature: "editable",
          maxLength: 25
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          fieldNature: "editable",
          maxLength: 1
        }
      ]
    : [
        {
          fieldLabel: "TSC Schedule Name",
          name: "tscScheduleName",
          label: "Schedule",
          type: "text",
          fieldNature: "editable",
          maxLength: 10
        },
        {
          fieldLabel: "TSC Description",
          name: "tscDescription",
          label: "Description",
          type: "text",
          fieldNature: "editable",
          maxLength: 25
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          fieldNature: "editable",
          maxLength: 1
        }
      ];

  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" }
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition)
  };

  const handleBack = () => {
    if (lookupType === "external") {
      const message = { type: "hideModal" };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: ""
        }
      ]
    : [
        {
          button_label: "Add TrOOP Schedule",
          button_handeler: () => {
            navigateToPage(TROOP_SCHEDULE_ADD, [
              {
                previousScreen: location.pathname
              }
            ]);
          },
          button_key: "F6"
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: ""
        }
      ];

  const menuOptions = useMemo(() => {
    return selectMode
      ? [
          {
            label: "Select",
            icon: <span className="material-icons">add</span>,
            command: () => {
              const paramDataMap = new Map();
              selectParams.forEach(key => {
              if (rowData.hasOwnProperty(key["target"])) {
                  paramDataMap.set(key["source"], rowData[key["target"]]);
              }
              });
              const paramData = Object.fromEntries(paramDataMap);
              if (lookupType !== "external") {
                onSelect(paramData);
              } else {
                const message = {
                  type: "responseData",
                  data: paramData
                };
                window.parent.postMessage(message, "*");
              }
            }
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              // const params =
              /*  const message = {
                message: "navigate-to-presto",
                programCode: "RCTSC002I",
                parameters: {
                  tscScheduleName: rowData.tscScheduleName,
                },
              };
            */ if (lookupType === "external") {
                const message = {
                  type: "navigateData",
                  data: {...rowData},
                  target: "TROOP_SCHEDULE_READ_ONLY"
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              } else {
                onNavigate({
                  navType: "local",
                  data: {...rowData},
                  target: ROUTE_PATHS.TROOP_SCHEDULE_DISPLAY,
                  schedulesDataKey: "selectedSchedules",
                  additionalData: {
                    paramsData: {}
                  }
                });
              }
            }
          },
          {
            label: "Steps",
            icon: <span className="material-icons">search</span>,
            command: () => {
              /*const message = {
                message: "navigate-to-presto",
                programCode: "RCTSD001I",
                parameters: {
                  tscScheduleName: rowData.tscScheduleName,
                  tscDescription: rowData.tscDescription,
                },
              };*/
              if (lookupType === "external") {
                const message = {
                  type: "navigateData",
                  data: { ...rowData},
                  target: "TROOP_SCHEDULE_STEPS"
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              } else {
                onNavigate({
                  navType: "local",
                  data: {...rowData},
                  target: ROUTE_PATHS.TROOP_SCHEDULE_STEP,
                  schedulesDataKey: "selectedSchedules",
                  additionalData: {
                    paramsData: {}
                  }
                });
              }
            }
          }
        ]
      : [
          {
            label: "Edit",
            icon: <span className="material-icons">edit</span>,
            command: () => {
              const selectedSchedulesData = selectedRows.length
                ? selectedRows
                : [rowData];
              const lastScheduleName =
                selectedSchedulesData[selectedSchedulesData.length - 1]
                  ?.tscScheduleName;
              const updatedParamsData = {
                ...paramsData,
                tscScheduleName: lastScheduleName
              };
              navigateToPage(TROOP_SCHEDULE_EDIT, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex
                },
                {
                  // selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.acmAccumulationCode],
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0
                }
              ]);
            }
          },
          {
            label: "Copy",
            icon: <span className="material-icons">content_copy</span>,
            command: () => {
              const selectedSchedulesData = selectedRows.length
                ? selectedRows
                : [rowData];
              const lastScheduleName =
                selectedSchedulesData[selectedSchedulesData.length - 1]
                  ?.tscScheduleName;
              const updatedParamsData = {
                ...paramsData,
                tscScheduleName: lastScheduleName
              };
              navigateToPage(COPY_TROOP_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname
                }
              ]);
            }
          },
          {
            label: "Delete",
            icon: <span className="material-icons">delete</span>,
            command: () => {
              openConfirmationModal();
            }
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              const selectedSchedulesData = selectedRows.length
                ? selectedRows
                : [rowData];
              const lastScheduleName =
                selectedSchedulesData[selectedSchedulesData.length - 1]
                  ?.tscScheduleName;
              const updatedParamsData = {
                ...paramsData,
                tscScheduleName: lastScheduleName
              };
              navigateToPage(TROOP_SCHEDULE_DISPLAY, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex
                },
                {
                  // selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.acmAccumulationCode],
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0
                }
              ]);
            }
          },
          {
            label: "Steps",
            icon: <span className="material-icons">list</span>,
            command: () => {
              const selectedSchedulesData = selectedRows.length
                ? selectedRows
                : [rowData];
              const lastScheduleName =
                selectedSchedulesData[selectedSchedulesData.length - 1]
                  ?.tscScheduleName;
              const updatedParamsData = {
                ...paramsData,
                tscScheduleName: lastScheduleName
              };
              navigateToPage(TROOP_SCHEDULE_STEP, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex
                },
                {
                  // selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.acmAccumulationCode],
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0
                }
              ]);
            }
          },
          {
            label: rowData[statusKey] === "Hidden" ? "Unhide" : "Hide",
            icon: <span className="material-icons">visibility_off</span>,
            command: () => {
              openHideConfirmationModal();
            }
          }
        ];
  }, [rowData]);

  const columnDef = [
    {
      header: "Schedule",
      field: "tscScheduleName"
    },
    {
      header: "Description",
      field: "tscDescription"
    },
    {
      header: "Steps",
      field: "tscStepCount"
    },
    {
      header: "Version",
      field: "tscVersion"
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator"
    }
  ];

  const parmKey = "tscScheduleName";

  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;

    const currentParams = paramsData;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/tscTroopScheduleCtl`,
        null,
        {
          page: page,
          size: rows,
          ...currentParams
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, hideFlag]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { tscScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/tscTroopScheduleCtl", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);

          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {}
          } = error.data;

          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const hideUnhideTroopSchedule = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        tscScheduleName: rowData[parmKey],
        screenNumber: screenNumber
      };
      axios_helper_no_header(
        "PUT",
        "api/tscTroopScheduleCtl/hideUnhide",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setHideFlag(!hideFlag);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000
          });
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error hiding/unhiding the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData, screenNumber };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/tscTroopScheduleCtl/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const url = new URL(event.origin);
    const hostnameWithoutPort = url.hostname;
    const trustedDomains= TRUSTED_DOMAIN.TRUSTED_DOMAINS;
    if (!trustedDomains.test(hostnameWithoutPort)) {
      console.warn("Blocked message from untrusted origin:", event.origin);
      return;
    }
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      setLookupType("external");
      setSelectParams(paramData.params);
      setParamsData({
        ...paramsData,
        ...paramData.paramsData
      });
      setDisabledDropdowns({ hiddenRecordIndicator: true });
      setSelectMode(selectMode);
    }
  };

  useEffect(() => {
    if (selectMode) {
      setDisabledDropdowns({ hiddenRecordIndicator: true });
    }
  }, [selectMode]);

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    selectMode,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
    hideUnhideTroopSchedule,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    disabledDropdowns
  };
};

export default useTrOOPSchedule;
